(() => {
  const source = document.currentScript?.dataset.controllerSrc;
  if (!source || window.variantCardAddToCartInitialized) return;
  let loading = false;
  const needsController = root => root instanceof Element && (
    root.matches('product-card, .js-variant-card-data') ||
    root.querySelector('product-card, .js-variant-card-data')
  );
  const observer = new MutationObserver(records => {
    if (records.some(record => Array.from(record.addedNodes).some(needsController))) load();
  });
  function load() {
    if (loading) return;
    if (window.variantCardAddToCartInitialized) {
      observer.disconnect();
      return;
    }
    loading = true;
    const script = document.createElement('script');
    script.src = source;
    script.onload = () => observer.disconnect();
    script.onerror = () => { loading = false; script.remove(); };
    document.head.append(script);
  }
  observer.observe(document.body, {childList: true, subtree: true});
  if (needsController(document.body)) load();
})();
